import { post } from "../api.helper";
import * as URL from "../url.helper";

export const callLoginUser = data => post(URL.LOGIN_URL, data, {skipInterceptor: true});
export const sendLoginOtp = data => post(URL.SEND_LOGIN_OTP, data, {skipInterceptor: true});
export const verifyMobileOtp = data => post(URL.VERIFY_MOBILE_OTP, data, {skipInterceptor: true});
export const callLogoutUser = data => post(URL.LOGOUT_URL, data);
export const callLoginUserFromMicrosoft = data => post(URL.LOGIN_FROM_MICROSOFT, data, {skipInterceptor: true});
export const callValidateUser = data => post(URL.VALIDATE_USER, data, {skipInterceptor: true});